import React from 'react';
import cn from 'classname';
import './index.less';

function SummarySection({ title, value, chart }) {
	return (
		<div className='analytics-summary-section'>
			<div className={cn('analytics-summary-chart', chart)} />
			<div className='analytics-summary-data'>
				<div className='analytics-summary-value font-proxima-nova-bold'>
					{value || 0}
				</div>
				<div className='analytics-summary-title'>
					{title}
				</div>
			</div>
		</div>
	);
}

export default SummarySection;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/info/components/Analytics/SummarySection/index.js